import type { App } from 'vue'
import VueSanitize from 'vue-sanitize-directive'

export function vueSanitizeDirective(app: App) {
  app.use(VueSanitize)
}
